<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <div class="title">{{title.lg1}}</div>
          <div class="subtitle">{{subtitle.lg1}}</div>
        </div>
        <div class="price float-right">{{price}}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1RatesRow',
  props: {
    servicesLg1: Object,
    servicesLg2: Object
  },
  computed: {
    title () {
      return {lg1: this.servicesLg1.label_value, lg2: this.servicesLg2.label_value}
    },
    subtitle () {
      return {lg1: this.servicesLg1.sub_label, lg2: this.servicesLg2.sub_label}
    },
    price () {
      return this.servicesLg1.msr_value
    },
    price2 () {
      return this.servicesLg2.msr_value
    },
    freeOfCharge () {
      if (this.price === this.price2) {
        return ''
      } else {
        return this.price2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibisstyles.scss";

#row {
  width: 100%;
  @include heightPercent(109);

  .row1 {
    margin-top: 0.3vh;
    height: 100%;

    .lg1 {
      overflow: hidden;
      color: black;

      .title {
        font-family: "Gotham-Book";
        @include fontSize(46);
      }

      .subtitle {
        font-family: "Gotham-BookItalic";
        @include fontSize(28);
         margin-top: -10px;
      }
    }

    .price {
      font-family: "Gotham-Bold";
      @include fontSize(46);
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibisstyles/rates/horizontal/v1/services/rowServices.vue